export const offersData = {
    data() {
        return {
            offersList: [
                {
                    id: 1,
                    order: 1,
                    sellerWitrinoCode: "5645564",
                    sellerPoloticCode: "6546555",
                    sellerName: "آتلیه خاطرات",
                    title: "تخفیف به مناسبت عید غدیر",
                    category: "زیورآلات",
                    discount: 20,
                    image: "https://mdbcdn.b-cdn.net/img/new/avatars/1.jpg",
                    beginDateValidity: "1401/04/12",
                    endDateValidity: "1401/05/12",
                    validityDuration: "12 مهر تا 14 مهر",
                    discription: "با خرید محصولات ما از هر محصول تخفیف دریافت نمائید"
                },
                {
                    id: 1,
                    order: 1,
                    sellerWitrinoCode: "5645564",
                    sellerPoloticCode: "6546555",
                    sellerName: "آتلیه خاطرات",
                    title: "تخفیف به مناسبت عید سعید فطر",
                    category: "پوشاک",
                    discount: 20,
                    image: "https://mdbcdn.b-cdn.net/img/new/avatars/1.jpg",
                    beginDateValidity: "1401/04/12",
                    endDateValidity: "1401/05/12",
                    validityDuration: "12 مهر تا 14 مهر",
                    discription: "با خرید محصولات ما از هر محصول تخفیف دریافت نمائید"
                },
                {
                    id: 1,
                    order: 1,
                    sellerWitrinoCode: "5645564",
                    sellerPoloticCode: "6546555",
                    sellerName: "آتلیه خاطرات",
                    title: "مدیریت",
                    category: "پوشاک",
                    discount: 20,
                    image: "https://mdbcdn.b-cdn.net/img/new/avatars/1.jpg",
                    beginDateValidity: "1401/04/12",
                    endDateValidity: "1401/05/12",
                    validityDuration: "12 مهر تا 14 مهر",
                    discription: "با خرید محصولات ما از هر محصول تخفیف دریافت نمائید"
                },
            ],
            offersCategory: ["پوشاک", "موادغذایی", "زیورآلات", "لوازم خانگی", "خودرو", "آرایشی و بهداشتی"]
        }
    },
    methods: {
        getOffersList() {
            return this.offersList;
        },
    }
}